import {useQuotesContext} from '../hooks/useQuotesContext'
import {useEffect, useState} from 'react'
import {useAuthContext} from "../hooks/useAuthContext"
import '../styling/QuotesList.css'
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config.js';



const QuotesList = ({searchTerm}) => {

  const navigate = useNavigate();
  const {quotes, dispatch} = useQuotesContext();
  const[deleteTrigger,setDeleteTrigger] = useState(false);
  const {user} = useAuthContext();



  const handleAccessClick = (quoteId) => {
    // Navigate to the ClientDetails page with the specific client ID
    navigate(`/quote/${quoteId}`);
  };

  const handleDelete = async (quote) => {
    
    if(!user){
      return
    }

    console.log(quote)
    const response = await fetch(`${API_BASE_URL}/api/quote/` + quote._id, {
      method: "DELETE",
      headers:{
        "Authorization": `Bearer ${user.token}`
      }
    })

    const json = await response.json()

    if(response.ok){
      dispatch({type: "DELETE_QUOTES", payload:json})
      setDeleteTrigger(!deleteTrigger)
    }

  }

  useEffect(() => {
    const fetchClients = async () => {

        const response = await fetch(`${API_BASE_URL}/api/quote`, {
            headers: {"Authorization": `Bearer ${user.token}`}
        })

        const json = await response.json()

        if(response.ok){
            dispatch({type: "SET_QUOTES", payload:json})
        }     
    }
    if (user){
        fetchClients()
    }  

// add clients to dependency below to update deleted client. 
  }, [dispatch,user, deleteTrigger])

  
  const filterQuotes = () => {
    if (searchTerm.trim() === '') {
      // If search term is empty, return all clients
      return quotes;
    }

    return quotes.filter(
      (quote) =>{
      const clientMatches =
      quote.client.clientFirst.toLowerCase().includes(searchTerm.toLowerCase()) ||
      quote.client.clientLast.toLowerCase().includes(searchTerm.toLowerCase()) ||
      quote.quoteTotal.toLowerCase().includes(searchTerm.toLowerCase());

      const lineItemMatches = quote.lineItems.some((lineItem) =>
      lineItem.productService.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Return true if either the client details or any line item matches the search term
    return clientMatches || lineItemMatches;
       } );
  };


    return ( 

        <div className="quoteslist">
            <div className="overflow-x-auto">
  <table className="table">
    {/* head */}
    <thead>
      <tr>
        <th>
          <label>

          </label>
        </th>
        <th>Name</th>
        <th>Product/Service</th>
        <th>Quote Total</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {/* row 1 */}

      {quotes && filterQuotes().map((quote) => {
  return (
    <tr key={quote._id}>
      <th>
        <label>

        </label>
      </th>
      <td>
        <div className="flex items-center gap-3">
          <div className="avatar">
            <div className="mask mask-squircle w-12 h-12">
            </div>
          </div>
          <div>
            <div className="font-bold">{quote.client.clientFirst} {quote.client.clientLast}</div>
            <div className="text-sm opacity-50">TBD</div>
          </div>
        </div>
      </td>
      <td>
        {quote.lineItems[0].productService} 
      </td>
      <td>{quote.quoteTotal}</td>
      <th>
      <button className="btn" id="quoteaccess" onClick={() => handleAccessClick(quote._id)}>
        Access
      </button>
      </th>
    </tr>
  );
})}


     
      </tbody>
    
  </table>
</div>
        </div>

    );
}
 
export default QuotesList;